const Notifications = ()=>{
    return (
        <div className="row position-relative z-index-2">
           
        <div className="row">
          <div className="col-lg-6 col-sm-12 ">
           <h1 className="n-2">
           Notification center
            </h1>
    
    
    
          </div>
          <div className="col-lg-6 col-sm-12">
           
    
    
    
          </div>
          
       
    
         
        </div>
        </div>
    
    )
}
export default Notifications ; 